import { MutationTree } from "vuex";
import { IFDGState } from "@/core/interfaces/state/fdgState.interface";
import { IFDG } from "@/core/interfaces/state/fdg.interface";
import { IFDGDetail } from "@/core/interfaces/state/fdgDetail.interface";
import {
  IFDGBookingDetail,
  IFDGBookingPassenger,
} from "@/core/interfaces/state/fdgBookingDetail.interface";

const mutations: MutationTree<IFDGState> = {
  enableIsFetchingGroupFlights(state) {
    state.isFetchingFDGList = true;
  },
  saveGroupFlights(state, payload: Array<IFDG>) {
    state.isFetchingFDGList = false;
    state.fdgList = payload;
  },
  enableIsFetchingGroupFlightDetail(state) {
    state.isFetchingFDGDetail = true;
  },
  saveGroupFlightDetail(state, payload: IFDGDetail) {
    state.isFetchingFDGDetail = false;
    state.fdgDetail = payload;
  },
  setOTPVerificationInProgress(state, payload: boolean) {
    state.isOTPVerificationInProgress = payload;
  },
  setGroupBookingPassengersFetching(state, payload: boolean) {
    state.isGroupBookingPassengersFetching = payload;
  },
  enableIsFetchingGroupFlightBookingDetail(state) {
    state.isFetchingFDGBookingDetail = true;
  },
  saveGroupFlightBookingDetail(state, payload: IFDGBookingDetail) {
    state.isFetchingFDGBookingDetail = false;
    state.fdgBookingDetail = payload;
  },
  enableIsInitiatingGroupFlightBooking(state) {
    state.isInitiatingFDGBooking = true;
  },
  disableIsInitiatingGroupFlightBooking(state) {
    state.isInitiatingFDGBooking = false;
  },
  enableIsConfirmGroupFlightBooking(state) {
    state.isConfirmFDGBooking = true;
  },
  disableIsConfirmGroupFlightBooking(state) {
    state.isConfirmFDGBooking = false;
  },
  enableIsConfirmGroupFlightBookingWithoutTravelerDetails(state) {
    state.isConfirmFDGBookingWithoutTravelerDetails = true;
  },
  disableIsConfirmGroupFlightBookingWithoutTravelerDetails(state) {
    state.isConfirmFDGBookingWithoutTravelerDetails = false;
  },
  saveGroupBookingPassengers(state, payload: IFDGBookingPassenger[]) {
    state.passengers = payload;
  },
  saveGroupBookingFormOTPReference(state, payload: string) {
    state.bookingFormOTPReference = payload;
  },
  setGroupFlightsPaynowLoading(state, payload: boolean) {
    state.isGroupFlightsPaynowLoading = payload;
  },
};

export default mutations;
